import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Button } from "@headlessui/react";
import phones from "../assets/images/phones.png";
import v1 from "../assets/video/v1.mp4";
import v2 from "../assets/video/v2.mp4";
import v3 from "../assets/video/v3.mp4";
import { Input, NativeSelect, NumberInput } from "@mantine/core";

const Wallet = () => {
  const cards = [
    {
      title: "Self-custody wallet",
      description:
        "Funds in the wallet are exclusively held and managed by the user. You are in complete control over your crypto assets.",
      videoSrc: v1,
    },
    {
      title: "Powered by MPC",
      description:
        "Advanced multi-party computation (MPC) technology creates three separately stored ‘key shares’. Enjoy unparalleled security without the need for a seed phrase.",
      videoSrc: v2,
      hasLearnMore: true,
    },
    {
      title: "Built-in risk controls",
      description:
        "Get alerts if a token or blockchain carries security risks, including wrong address protection or malicious contract detection.",
      videoSrc: v3,
    },
  ];
  return (
    <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
      <Header />
      <div className="py-6">
        <div className="container">
          <div className="block mb-6 mt-8">
            <h1 className="text-yellow-400 text-5xl font-bold">Wallet</h1>  

            <h2 className="text-4xl font-extrabold mt-2">
              Web3 is easier with Tillionx
            </h2>
            <h2 className="text-4xl font-extrabold">
              
            </h2>
            <div className="mt-6 w-full mx-auto">
              <NativeSelect label="Select Method" data={['Tron', 'Tron']} />
              <div className="lg:flex mt-4">
                <NumberInput
                placeholder="Enter Amount"
                className="text-sm bg-gray-50 w-full"
              />
              <Button
                className="bg-yellow-400 px-6 py-1 rounded-md font-semibold text-black lg:ml-8 w-full mt-2 lg:mt-0"
                style={{ color: "#000" }}
              >
                Withdrawal
              </Button>
              </div>
            </div>
          </div>
          <div className="justify-center flex hidden md:flex mt-16 mb-8 pb-8">
          <img src={phones} alt="Wallet" className="h-auto w-2/3" />
        </div>
        </div>
      </div>

      <div className="bg-[#0d0d0d] pt-10 pb-[82px] md:pt-20 md:pb-[122px] lg:py-[120px]">
        <section className="mx-auto w-full px-4">
          <div>
            <h3 className="flex flex-col items-center text-3xl font-semibold text-white mb-10 lg:mb-20 xl:flex-row xl:gap-4 xl:justify-center">
              <span>Putting you in control.</span>
              <span>Security at every stage.</span>
            </h3>

            <div className="flex flex-wrap justify-center gap-6">
              {cards.map((card, index) => (
                <div
                  key={index}
                  className="relative bg-[#1a1a1a] h-[473px] rounded-2xl p-6 pb-0 md:w-[327px] lg:h-[520px] lg:w-[340px] lg:p-10 xl:w-[472px]"
                >
                  <div className="text-xl font-semibold text-white mb-4">
                    {card.title}
                  </div>
                  <div className="text-sm text-gray-400 mb-4">
                    {card.description}
                    
                  </div>
                  <video
                    className="absolute bottom-[54px] left-0 right-0 mx-auto w-[279px] lg:w-[392px]"
                    style={{
                      background: "transparent",
                      clipPath: "inset(2px)",
                      outlineOffset: "-2px",
                      outline: "2px solid #181A20",
                    }}
                    autoPlay
                    loop
                    muted
                    playsInline
                    src={card.videoSrc}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    
      <Footer />
    </div>
  );
};

export default Wallet;
